import { render, staticRenderFns } from "./CaixaLista.vue?vue&type=template&id=504816fe&scoped=true&"
import script from "./CaixaLista.vue?vue&type=script&lang=js&"
export * from "./CaixaLista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504816fe",
  null
  
)

export default component.exports